import { WebUrl } from "shared-web/lib/webUrl"

export const adminCompanyEcommerceSectionId = "ecommerce"

export function adminCompany(): WebUrl {
  return {
    pathname: "/admin/company",
  }
}

export function adminCustomer(): WebUrl {
  return {
    pathname: "/admin/customer",
  }
}

export function adminProduct(): WebUrl {
  return {
    pathname: "/admin/product",
  }
}

export function adminTags(): WebUrl {
  return {
    pathname: "/admin/tags",
  }
}

export function adminCommunications(): WebUrl {
  return {
    pathname: "/admin/communications",
  }
}

export function adminSecurity(): WebUrl {
  return {
    pathname: "/admin/security",
  }
}

export function adminStripe(): WebUrl {
  return {
    pathname: "/admin/stripe",
  }
}
